import { render } from "./AvatarSelection.vue?vue&type=template&id=43706fb4&scoped=true"
import script from "./AvatarSelection.vue?vue&type=script&lang=js"
export * from "./AvatarSelection.vue?vue&type=script&lang=js"

import "./AvatarSelection.vue?vue&type=style&index=0&id=43706fb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43706fb4"]])

export default __exports__